export default "__VITE_ASSET__Dd8wzSt2__"